import React from 'react';
import { useSelector } from 'react-redux';

import { Headerbar, NotifPreview, Loader, FormInput, Select, ListContainer, YesNo, ConfirmButton } from '../../Reusable'

import { Fire, Time, Tools } from '../../../services'

import FadeIn from 'react-fade-in';

const { useHistory } = require('react-router-dom')

const ExpandedComponent: React.FC<any> = (props) => {
  const { data, refresh } = props

  const [ad, setAd] = React.useState<any>(null)
  const [loading, setLoading] = React.useState(false)

  const load = async () => {
    if (!data.adId)
      return;
    setLoading(true)
    try {
      const ad = await Fire.doc(Fire.collection('ads').doc(data.adId))
      if (!ad) {
        setAd({ name: "L'annonce associée n'existe plus !" })
      } else {
        setAd(ad)
      }
    } catch (err) {
      setAd({ name: "Erreur de connexion" })
    }
    setLoading(false)
  }

  React.useEffect(() => { load() }, [])

  return (
    <div style={{borderBottom: '1px solid #ddd'}}>
      <div style={{marginTop: 20, marginBottom: 20, fontSize: 15}}>
        { loading ? (
          <div>Chargement...</div>
        ) : ad ? (
          <div>Redirection associée: {ad.name}</div>
        ) : (
          <div>Aucune redirection associée</div>
        ) }
      </div>

      <NotifPreview
        title={data.title}
        message={data.message}
        />
    </div>
  )
}

interface Props {
  user: any;
  history: any;
}
const NotifsScreen: React.FC<Props> = (props: Props) => {
  
  const user = useSelector(state => state.authReducer.user) 
  const history = useHistory() 
  const [error, setError] = React.useState('')
  const [push, setPush] = React.useState<any>({ date: null })
  const [loading, setLoading] = React.useState(false)
  const [sending, setSending] = React.useState(false)

  const onFetch = async () => {
    try {
      const ref = Fire.store().collection('notifs')
        .where("type", "==", "all")
        .orderBy('createdAt', 'desc')
      const list = await Fire.list(ref)
      for (const item of list) {
        item.type_col = item.date ? 'Planifié' : 'Instantané'
        item.status_col = item.cancelled ? 'Annulé' : item.was_sent ? 'Envoyé' : 'En attente'
        item.date_send_col = Fire.getDateFor(item.date || item.createdAt)
        item.date_col = Time.moment(Fire.getDateFor(item.date || item.createdAt)).format('DD/MM/YYYY HH[h]mm')
        item.sent_col = item.sent || 0
        item.clicks_col = item.clicks || 0
      }
      return list
    } catch (err) {
      setError("Impossible de charger les notifications")
      console.warn(err)
    }
    return []
  }
  const sorting = (search: string, items: any[]) => {
    return items.filter((item) => Tools.matchesSearch(search, item.title) || Tools.matchesSearch(search, item.title))
  }

  const onCancel = async (notif: any, refresh: any) => {
    try {
      const ref = Fire.collection('notifs').doc(notif.id)
      await ref.update({ cancelled: true })
      refresh()
    } catch (err) {
      console.log(err)
    }
  }

  /*
  const lastPush = pushHistory && pushHistory.length ? pushHistory[0] : null
  let lastPushDate = lastPush ? Fire.getDateFor(lastPush.createdAt) : null
  if (lastPushDate)
    lastPushDate.setDate(lastPushDate.getDate() + 1)
  */

  return (
    <div className="wrapper">
      <Headerbar
        title="Notifications"
        />
      <div className="content-wrapper">
        <div className="content admin-push">
          <div className="container-fluid">

            <FadeIn>
            
            <ListContainer
              title="Historique des notifications"
              searchTitle="Rechercher une notification..."
              createTitle="Envoyer une notification"
              onCreate={() => history.push('/admin/notif')}
              error={error}
              onFetch={onFetch}
              sorting={sorting}
              renderColumns={({ refresh }) => ([
                { name: "Date d'envoi", date: 'date_send_col', sortable: true, accessor: 'date_col' },
                { name: 'Titre', string: 'title', sortable: true, accessor: 'title' },
                { name: "Nb. envoyées", sortable: true, accessor: 'sent_col' },
                { name: "Nb. ouvertures", sortable: true, accessor: 'clicks_col' },
                { name: 'Type', string: 'type_col', sortable: true, accessor: 'type_col' },
                { name: 'Statut', string: 'status_col', sortable: true, accessor: 'status_col' },
                { name: 'Actions', width: 180, accessor: 'actions', hasButton: true, cell: (item) => (
                  <ConfirmButton
                    title={"Annuler l'envoi"}
                    disabled={item.cancelled || !item.date || item.was_sent}
                    confirmTitle={'Êtes-vous sûr de vouloir vous annuler cette notification ?'}
                    onPress={(e) => {
                      e.stopPropagation();
                      onCancel(item, refresh)
                    }} />
                  )},
              ])}
              expandableRow={(item: any, refresh) => (
                <ExpandedComponent data={item} refresh={refresh} />
              )}
              />

            </FadeIn>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotifsScreen